import {createLocalizationContext} from "@variocube/cube-ui";
import * as en from "./en.json";
import * as de from "./de.json";
import * as cs from "./cs.json";
import * as pl from "./pl.json";
import * as tr from "./tr.json";

export const {LocalizationProvider, useLocalization, SUPPORTED_LANGUAGES} = createLocalizationContext({
    en,
    de,
    cs,
    pl,
    tr
});
